import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import SpiMenu from './SpiMenu';
import MarkerMaps from './MarkerMaps';
import PcpnTable from './PcpnTable';
import MapLegend from './MapLegend';
import RegionHeader from './RegionHeader';
import Error from './Error';
import ColorsContext from './ColorsContext';
import { getDefaultDate, setLongmonyr } from './routines';

export default function PcpnRegion(props) {
	const monyr = props.date ? props.date : getDefaultDate();
	const areaType = props.areaType;
	const [ markers, setMarkers ] = useState(null);
	const [ regionData, setRegionData ] = useState(null);
	const [ regionError, setRegionError ] = useState(false);
	const [ regionColors, setRegionColors ] = useState([]);
	const [ mapspi, setMapspi ] = useState(monyr.length <= 7 ? "1-month" : "30-day");
	const { levelColors, pctlColors } = useContext(ColorsContext);

	const monthSpiList = ["1-month", "2-month", "3-month", "6-month", "9-month", "12-month", "24-month", "36-month"];
	const daySpiList = ["30-day", "60-day", "90-day", "180-day", "270-day", "365-day", "730-day", "1095-day"];

	const selectedState = "ma";
	const ptDataFileNameBase = areaType === "region" ? "station_precip" : "station_basin_precip";
    const ptDataFileName = (props.match ? "." : ".") + "/data/" +  ptDataFileNameBase + "_" + monyr + ".json";
	const rgDataFileNameBase = areaType === "region" ? "regional_precip" : "basin_precip";
    const rgDataFileName = (props.match ? "." : ".") + "/data/" + rgDataFileNameBase + "_" + monyr + ".json";
    const spiList = monyr.length <= 7 ? monthSpiList : daySpiList;
    const longmonyr = setLongmonyr(monyr);
	const buttonValue = monyr.length === 7 ? (areaType === 'region' ? "pcpnstation" : "pcpnbasinstation") : (areaType === 'region' ? "pcpnwkstation" : "pcpnwkbasinstation");
	const addtext =  monyr.length > 7 
		? "These data are updated weekly. The values reflect the selected look-back period shown at the bottom of the map with the end date indicated on the map. Data may be provisional."
		: "Data may be provisional.";

	const basin_geodata = require('./geo/majorBasins_geo.json');

	const getPointData = () => {
		let allmarkers = [];
		axios.get(ptDataFileName)
		.then(results => {
			Object.keys(results.data.data).forEach(region => {
				Object.keys(results.data.data[region]).forEach(sky => {
					const stn = results.data.data[region][sky];
					if (stn[mapspi]) {
						const val = stn[mapspi].pctl.toFixed(0);
						let fcolor = 9;
						pctlColors.some((e, i) => {
							fcolor = e.color;
							return val > e.range[0] && val <= e.range[1];
						});
						allmarkers.push({
							position: stn.position, 
							fillColor: fcolor, 
							data: [stn.name,mapspi+" SPI: "+stn[mapspi].spi + "; Percentile: " + val]
						});
					}
				});
			});
			setMarkers(allmarkers);
		})
		.catch(err => {
			console.log("Point Data Error: " + err);
			setRegionError(true);
		});
	}

	const getRegionData = () => {
		axios.get(rgDataFileName)
		.then(results => {
			setRegionData(results.data.data);
			let allRegions = [];
			Object.keys(results.data.data).forEach(region => {
				const zone = results.data.data[region].zone
				// --- Don't color fill regions ---
				//const { level } = results.data[region][mapspi];
				//allRegions[zone] = levelColors[level];
				allRegions[zone] = levelColors.plain;
			});
			setRegionColors(allRegions);

		})
		.catch(err => {
			console.log("Region Data Error: " + err);
			setRegionError(true);
		});
	}

	useEffect(() => {
		setMarkers([]);	//needed to clear fillColor of markers on map
		getPointData();
		getRegionData();
		setRegionError(false)
		 // eslint-disable-next-line
	}, [ mapspi ])

	return (
		<>
			{!regionError &&
				<RegionHeader
					title={"Precipitation Summary"}
					buttontext={"View Individual Station Data"}
					addtext={addtext}
					buttonValue={buttonValue}
					handleButtonClick={props.handleButtonClick}
				/>
			}
			{markers &&
				<>
					<div tabIndex={-1} className="mapandlegend-container">
						<MarkerMaps 
							selectedState={selectedState} 
							markers={markers} 
							regionColors={regionColors}
							mapTitle={longmonyr + " " + mapspi +" SPI"}
							geo={areaType === 'basin' ? basin_geodata : "drought"}
						/>
						<MapLegend 
							title="Point Values - SPI Percentiles"
						/>
					</div>
					<SpiMenu
						setMapspi={setMapspi}
						spiList={spiList}
					/>
				</>
			}
			{regionData &&
				<PcpnTable
					regionData={regionData}
					monyr={longmonyr}
					spiList={spiList}
					areaType={areaType}
				/>
			}
			{regionError &&
				<>
					<Error />
				</>
			}
	   </>
	);
}